var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "profile-input-wrapper" },
    [
      _c(
        "profile-form",
        {
          ref: "form",
          attrs: { endpoint: "otherpreferences" },
          on: {
            error: function ($event) {
              return this.$emit("done", $event)
            },
          },
        },
        [
          _c("form", { staticClass: "form" }, [
            _c("fieldset", [
              _c("legend", { staticClass: "sr-only" }, [
                _vm._v(_vm._s(_vm.inputTitle)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "profile-input-label" }, [
                _vm._v(_vm._s(_vm.listLabel)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex-grid-1-col gutter-lg" }, [
                _c(
                  "ul",
                  {},
                  [
                    _vm.hasSelectAll
                      ? _c(
                          "li",
                          {
                            staticClass: "profile-input-checkbox",
                            staticStyle: { "margin-bottom": "8px" },
                          },
                          [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectAll,
                                    expression: "selectAll",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(_vm.selectAll)
                                    ? _vm._i(_vm.selectAll, null) > -1
                                    : _vm.selectAll,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.selectAll,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.selectAll = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.selectAll = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.selectAll = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.selectAllLabel) +
                                  "\n              "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.interestsList, function (interest, index) {
                      return _c(
                        "li",
                        { key: index, staticClass: "profile-input-checkbox" },
                        [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.localProfile.communicationInterest,
                                  expression:
                                    "localProfile.communicationInterest",
                                },
                              ],
                              attrs: {
                                type: "checkbox",
                                id: interest.value,
                                name: "interest-" + interest.value,
                                "data-field-type": "CheckBoxSet",
                              },
                              domProps: {
                                value: interest.label,
                                checked:
                                  _vm.localProfile.communicationInterest.includes(
                                    interest.label
                                  ),
                                checked: Array.isArray(
                                  _vm.localProfile.communicationInterest
                                )
                                  ? _vm._i(
                                      _vm.localProfile.communicationInterest,
                                      interest.label
                                    ) > -1
                                  : _vm.localProfile.communicationInterest,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a =
                                      _vm.localProfile.communicationInterest,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = interest.label,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.localProfile,
                                          "communicationInterest",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.localProfile,
                                          "communicationInterest",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.localProfile,
                                      "communicationInterest",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                            _vm._v(
                              "\n                " +
                                _vm._s(interest.label) +
                                "\n              "
                            ),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("input", {
              attrs: {
                value: "true",
                type: "hidden",
                name: "isOtherPreferences",
              },
            }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }